import React from 'react';

import { useRouter } from 'next/router';

import { AppServicesContext } from '@kamernet/core/AppServices';
import { AuthContext } from '@kamernet/core/Auth/AuthContext';
import { useLocalStorage } from '@kamernet/core/BrowserStorage';
import { reportError } from '@kamernet/core/Errors';

import {
  getEmptyListingsSearchAllFilters,
  mapListingsSearchAllFiltersToListingRequest,
} from '../utilities';

export const FlushAnonymousPSA = () => {
  const router = useRouter();
  const { isAuthenticated, userProfile } = AuthContext.useContext();
  const { apiClient } = AppServicesContext.useContext();

  const [anonymousPSA, setAnonymousPSA, isAnonymousPSAReady] = useLocalStorage(
    'kn-anonymous-psa-v2',
  );

  React.useEffect(() => {
    const flush = async () => {
      if (
        isAnonymousPSAReady &&
        isAuthenticated &&
        typeof router.query.signedin === 'string' &&
        router.query.signedin.toLowerCase() === 'true'
      ) {
        setAnonymousPSA(undefined);

        if (
          !userProfile?.haspremiumaccount &&
          anonymousPSA?.allFiltersArray &&
          anonymousPSA.allFiltersArray.length > 0
        ) {
          const psaList = (anonymousPSA?.allFiltersArray || []).map(
            allFilters => {
              const emptyAllFilters = getEmptyListingsSearchAllFilters();
              return mapListingsSearchAllFiltersToListingRequest({
                ...emptyAllFilters,
                ...allFilters,
              });
            },
          );

          await apiClient.alert.processAnonymousPSA({
            processAnonymousPSARequest: {
              psaList,
            },
          });
        }
      }
    };

    flush().catch(error => {
      reportError(
        new Error('Error flushing anonymous psa', {
          cause: error,
        }),
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAnonymousPSAReady]);

  return null;
};
